import React from 'react'
import styled from 'styled-components'
import { Block, Button } from '@mote/ui'
import { Logo } from '@mote/assets/icons'
import { useHistory } from 'react-router-dom'

export const AdminHeader = () => {
  const history = useHistory()

  return (
    <Root>
      <LogoContainer onClick={_ => history.push('/')}>
        <Logo style={{ marginRight: 60 }} />
      </LogoContainer>
      <Block layout='horizontal' gap={20}>
        <Button
          tag='a'
          variant='link-secondary'
          href='/admin/users'
          text='Users'
        />
        <Button
          tag='a'
          variant='link-secondary'
          href='/admin/schools'
          text='Schools'
        />
        <Button
          tag='a'
          variant='link-secondary'
          href='/admin/debugSAK'
          text='DebugSAK (Swiss Army Knife) &trade;	'
        />
      </Block>
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
`

const LogoContainer = styled.div`
  cursor: pointer;
`
